import axios from "axios";
import Config from "../utils/Config";
const BASE_URL = `${Config.API_BASE_URL}/admin`;

class StudentsService {
  getHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
      },
    };
  }

  async getAllStudents() {
    try {
      const response = await axios.get(
        `${BASE_URL}/get/all/student`,
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data?.data || response.data,
        message:
          response.data?.data?.reason ||
          response.data?.message ||
          "Students fetched successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error.response?.data?.data?.reason ||
          error.response?.data?.message ||
          "An error occurred while getting students",
      };
    }
  }

  async getStudentsByAgent(agentSlug) {
    try {
      const response = await axios.get(
        `${Config.API_BASE_URL}/admin/agent/students/${agentSlug}`,
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data?.data || response.data,
        message:
          response.data?.data?.reason ||
          response.data?.message ||
          "Students fetched successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error.response?.data?.data?.reason ||
          error.response?.data?.message ||
          "An error occurred while getting students",
      };
    }
  }

  async activateStudent(studentSlug) {
    try {
      const response = await axios.get(
        `${BASE_URL}/activate/student/${studentSlug}`,
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data?.data || response.data,
        message:
          response.data?.data?.reason ||
          response.data?.message ||
          "Student activated successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error.response?.data?.data?.reason ||
          error.response?.data?.message ||
          "An error occurred while activating student",
      };
    }
  }

  async updateStudent(studentSlug, payload) {
    try {
      const response = await axios.post(
        `${BASE_URL}/update/student/${studentSlug}`,
        payload,
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data?.data || response.data,
        message:
          response.data?.data?.reason ||
          response.data?.message ||
          "Student updated successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error.response?.data?.data?.reason ||
          error.response?.data?.message ||
          "An error occurred while updating student",
        validationErrors: error.response?.data?.errors || null,
      };
    }
  }
}

const studentsService = new StudentsService();
export default studentsService;
